import { render } from "./TemaGroentstrukturOgBiodiversitet.vue?vue&type=template&id=ab80ee20"
import script from "./TemaGroentstrukturOgBiodiversitet.vue?vue&type=script&lang=js"
export * from "./TemaGroentstrukturOgBiodiversitet.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__